var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-layout',[_c('StrukturBilanzTable',{ref:"kdfTable",attrs:{"hasAmpel":true,"sortDisabled":true,"heightSub":_vm.tableHeightSub,"tableName":"","edoClassName":"kz"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9587fb7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/akte/TabKDF.vue
// module id = null
// module chunks = 